<template>
    <div class="dashboard__list_trainer">
        <component-induction-message
            :title="'My training'"
            :content="'If you’re seeing this page then you must be a trainer!\n'+
            '\n'+
            'All the events, assessments or registers that require your input are below.'"
            :link-to="''"
            :theme="'primary'"
            :route-name="'dashboard-trainer'"
        ></component-induction-message>
        <div class="dashboard__list_trainer_main">
            <dashboard-list-trainer-active-sessions/>
            <dashboard-list-trainer-complete-sessions/>
        </div>
    </div>
</template>

<script>
import DashboardListTrainerActiveSessions from '@/components/dashboard/list/trainer/DashboardListTrainerActiveSessions'
import DashboardListTrainerCompleteSessions from '@/components/dashboard/list/trainer/DashboardListTrainerCompleteSessions'
import ComponentInductionMessage from '@/components/default/shared/ComponentInductionMessage'

export default {
  name: 'dashboard-list-trainer',
  components: { ComponentInductionMessage, DashboardListTrainerCompleteSessions, DashboardListTrainerActiveSessions },
  computed: {
    userName () {
      return this.$store.getters.getAuthUserSecondStageTokenDataNameOutput
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/dashboard/list/_dashboardlist.scss";
</style>
